export const toNumber = (value: any | null): number =>  value ? +value : 0;
